<template>
    <div id="app" v-bind:class="[fontSize, {openDyslexicFont: openDyslexicToggle}, {animationsActive: animationsToggle}]">
        <router-view v-bind:fontSize="fontSize" :key="$route.path"></router-view>
    </div>
</template>

<script>

// Internal services js
import { EventBus } from '@/helpers/EventBus.js';
import { Default }  from '@/helpers/Default.js';

export default {
    name: 'App',
    data () {
        return {
            fontSize:           Default.fontSize,
            openDyslexicToggle: Default.openDyslexicToggle,
            animationsToggle:   Default.animationsToggle,
            transitionName:     'slide-fade'
        };
    },
    mounted () {
        if (this.$session.has('animationsToggle')) {
            this.animationsToggle = this.$session.get('animationsToggle');
        }

        if (this.$session.has('openDyslexicToggle')) {
            this.openDyslexicToggle = this.$session.get('openDyslexicToggle');
        }

        if (this.$session.has('growFont')) {
            this.resetFontSize(this.$session.get('growFont'));
        }

        // Listen for OpenDyslexic font setting value
        EventBus.$on('settingsChanged', (setting) => {
            this[setting.name] = setting.value;
        });

        // Listen for font size value
        EventBus.$on('grow-font', this.resetFontSize);

        // Listen for a game reset
        EventBus.$on('reset', this.resetGame);
    },

    methods: {
        /**
         * Reset the font size
         *
         * @param      {string}  size    The size
         */
        resetFontSize (size) {
            this.fontSize['normal-font'] = false;
            this.fontSize['big-font']    = false;
            this.fontSize['giant-font']  = false;
            this.fontSize[size]          = true;
        },

        /**
         * Reset the game.
         */
        resetGame () {
            // Destroy the session
            this.$session.destroy();

            // Reset animations to default
            EventBus.$emit('settingsChanged', {
                name:  'animationsToggle',
                value: Default.animationsToggle
            });

            // Reset open dyslexic font to default
            EventBus.$emit('settingsChanged', {
                name:  'openDyslexicToggle',
                value: Default.openDyslexicToggle
            });

            // Reset font size to default
            EventBus.$emit('grow-font', Default.size);
        }
    }
};
</script>

<style>
    @import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
</style>
